import React from "react";
import { Helmet } from 'react-helmet-async';
import "../../../assets/styles/SocialMarketing.css";
import socialHero from "../../../assets/images/social.jpg";
import socialStrategy from "../../../assets/images/social.jpg";

const SocialMarketingPage = () => {
    return (
        <>
        <Helmet>
        <title>Social Media Marketing – BuddyTech Solutions</title>
        <meta name="description" content="Grow your brand online with strategic social media marketing including content creation, scheduling, and paid campaigns." />
        <meta name="keywords" content="social media marketing, Instagram marketing, Facebook marketing, social ads, content strategy, reels, digital engagement" />

        <meta property="og:title" content="Social Media Marketing – BuddyTech Solutions" />
        <meta property="og:description" content="Grow your brand online with strategic social media marketing including content creation, scheduling, and paid campaigns." />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/marketing/social" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Social Media Marketing – BuddyTech Solutions" />
        <meta name="twitter:description" content="Grow your brand online with strategic social media marketing including content creation, scheduling, and paid campaigns." />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
        <div className="social-container">
            <header className="social-hero">
                <div className="social-hero-content">
                    <h1>Social Media Marketing</h1>
                    <p>
                        We help brands grow and engage with audiences across platforms through creative content, strategy, and paid campaigns.
                    </p>
                </div>
                <img src={socialHero} alt="Social Hero" className="social-hero-img" />
            </header>

            <section className="social-section">
                <div className="social-text">
                    <h2>What We Offer</h2>
                    <p>
                        From content calendars to ad creatives, our team delivers performance-driven social media strategies tailored to your goals.
                    </p>
                    <ul>
                        <li>Content Planning & Scheduling</li>
                        <li>Platform-Specific Strategy (IG, FB, X, LinkedIn)</li>
                        <li>Creative Design & Reels</li>
                        <li>Hashtag & Trend Research</li>
                        <li>Paid Social Campaigns & Analytics</li>
                    </ul>
                </div>
                <img src={socialStrategy} alt="Social Strategy" className="social-img" />
            </section>

            <section className="social-tools">
                <h2>Platforms & Tools</h2>
                <div className="tools-grid">
                    <span>Meta Business Suite</span>
                    <span>Hootsuite</span>
                    <span>Buffer</span>
                    <span>Canva</span>
                    <span>Instagram Creator Studio</span>
                    <span>LinkedIn Ads</span>
                    <span>Google Ads</span>
                    <span>Adobe Express</span>
                </div>
            </section>
            <section className="contact-options">
                <div className="contact-card email">
                    <h2>📧 Email</h2>
                    <p>Send us an email for inquiries, support or collaboration opportunities.</p>
                    <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
                        Send Email
                    </a>
                </div>

                <div className="contact-card whatsapp">
                    <h2>💬 WhatsApp</h2>
                    <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
                    <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
                        Chat on WhatsApp
                    </a>
                </div>

                <div className="contact-card phone">
                    <h2>📞 Call Us</h2>
                    <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
                    <a href="tel:+919842084312">Call Us</a>
                </div>
            </section>
        </div>
        </>
    );
};

export default SocialMarketingPage;
